import { useCallback, useEffect, useState } from 'react'
import { GridRowId } from '@mui/x-data-grid-pro'
import { useBulkActionContext } from '../../../BulkActionContext'
import { bulkActionErrors } from '../../../constants'
import { ErrorSummary, ValidationCallback } from '../typings'
import { produce } from 'immer'
import { BulkUpdateExpectedClosingDateDTO } from '../../../typings/BulkUpdateExpectedClosingDate'

function formatErrors(dto?: BulkUpdateExpectedClosingDateDTO) {
  const errors = new Map<GridRowId, string[]>()
  if (!!dto) {
    const { alreadyClosedEntities } = dto

    const closed = alreadyClosedEntities === null ? [] : alreadyClosedEntities
    const hasAlreadyClosed = closed.length > 0
    closed.map((e) => {
      errors.set(e.entityId, [
        bulkActionErrors.updateExpectedClosingDate.closed.rowError,
      ])
    })

    return {
      errors,
      hasAlreadyClosed,
    }
  }
  return {
    errors,
    hasAlreadyClosed: false,
  }
}

export const useValidateRows = (validateRows: ValidationCallback) => {
  const {
    selectedRows,
    dispatch,
    state: { isValidating },
  } = useBulkActionContext()

  const [errorSummary, setErrorSummary] = useState<ErrorSummary>({
    count: 0,
    hasAlreadyClosed: false,
  })

  const updateState = useCallback(
    (dto?: BulkUpdateExpectedClosingDateDTO) => {
      const { errors, hasAlreadyClosed } = formatErrors(dto)
      dispatch({ type: 'setErrors', payload: errors })
      setErrorSummary((prev) =>
        produce(prev, (draft) => {
          draft.count = errors.size
          draft.hasAlreadyClosed = hasAlreadyClosed
        }),
      )
    },
    [dispatch],
  )

  useEffect(() => {
    let mounted = true

    const doValidation = async () => {
      dispatch({ type: 'startValidating' })

      const dto = await validateRows({
        ids: selectedRows.map((id) => Number(id)),
        expectedClosingDate: null,
      })

      if (mounted) updateState(dto)
    }
    const shouldValidate = selectedRows.length > 0
    if (shouldValidate) doValidation()
    else updateState()

    return () => {
      mounted = false
    }
  }, [dispatch, selectedRows, updateState, validateRows])

  return {
    errorSummary,
    loading: isValidating,
  }
}
